export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const CLEAR_CART_ITEM = "CLEAR_CART_ITEM";
export const SAVE_CART_SHIPPING_ADDRESS = "SAVE_CART_SHIPPING_ADDRESS";
export const SAVE_CART_PAYMENT_METHOD = "SAVE_CART_PAYMENT_METHOD";
